module.exports = __webpack_public_path__ + "static/giant_badger_mtg_clb-3420611786f676362ee3d25611993343.jpg";